var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work_orders_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,46.3H9.7c-3.1,0-5.7-2.6-5.7-5.7V10.2c0-3.1,2.6-5.7,5.7-5.7h3.8c1.1,0,1.9,0.9,1.9,1.9v5.1h15.2V6.4 c0-1.1,0.9-1.9,1.9-1.9h3.8c3.1,0,5.7,2.6,5.7,5.7v30.4C42,43.8,39.5,46.3,36.3,46.3z M9.7,8.3c-1,0-1.9,0.9-1.9,1.9v30.4 c0,1.1,0.9,1.9,1.9,1.9h26.6c1.1,0,1.9-0.9,1.9-1.9V10.2c0-1-0.9-1.9-1.9-1.9h-1.9v5.1c0,1.1-0.9,1.9-1.9,1.9h-19 c-1.1,0-1.9-0.9-1.9-1.9V8.3H9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.9,9.2h-3.8c-2.1,0-3.8-1.7-3.8-3.8V3.5c0-2.1,1.7-3.8,3.8-3.8h3.8c2.1,0,3.8,1.7,3.8,3.8v1.9 C28.7,7.5,27,9.2,24.9,9.2z M21.1,3.5L21.1,3.5v1.9h3.8V3.5H21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,15.5h-19c-1.1,0-1.9-0.9-1.9-1.9v-12c0-1.1,0.9-1.9,1.9-1.9h19c1.1,0,1.9,0.9,1.9,1.9v12 C34.4,14.6,33.6,15.5,32.5,15.5z M15.4,11.7h15.2V3.5H15.4V11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8,26.3H13.5c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h13.3c1.1,0,1.9,0.9,1.9,1.9 C28.7,25.5,27.9,26.3,26.8,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,33.9h-9.5c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9H23c1.1,0,1.9,0.9,1.9,1.9S24.1,33.9,23,33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkorders);
export default __webpack_public_path__ + "static/media/Work orders.c9d81fc6ef6160aa1b190375108da0e3.svg";
export { ForwardRef as ReactComponent };